import { useAtom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

const STORAGE_KEY = 'enrichContactsUnlocked';

type EnrichContactsUnlockedMap = Record<string, boolean>;

const storage = createJSONStorage<EnrichContactsUnlockedMap>(() => sessionStorage);

const enrichContactsUnlockedAtom = atomWithStorage<EnrichContactsUnlockedMap>(
  STORAGE_KEY,
  {},
  storage,
);
enrichContactsUnlockedAtom.debugLabel = STORAGE_KEY;

function compoundKey(
  documentId: string | undefined,
  relatedContactId: string | number | null | undefined,
): string | null {
  if (!documentId || relatedContactId == null || relatedContactId === '') {
    return null;
  }

  return `${documentId}:${String(relatedContactId)}`;
}

/**
 * Session-scoped flag: user has chosen to reveal AI contact enrichment for a
 * document + related contact pair.
 */
export const useEnrichContactsUnlocked = (
  documentId: string | undefined,
  relatedContactId: string | number | null | undefined,
) => {
  const [unlockedMap, setUnlockedMap] = useAtom(enrichContactsUnlockedAtom);
  const key = compoundKey(documentId, relatedContactId);
  const isUnlocked = key ? !!unlockedMap[key] : false;

  const markUnlocked = () => {
    if (!key) {
      return;
    }

    setUnlockedMap((prev) => ({ ...prev, [key]: true }));
  };

  return { isUnlocked, markUnlocked };
};
